import { useTranslation } from 'react-i18next';

export const EmbeddedAppContactSupportLink = () => {
  const { t } = useTranslation();

  const SUPPORT_LINK = 'https://dcloud2-lon.cisco.com/support/tickets';
  const EN_PATH = 'sessions.tabs.launchPanel.support';

  return (
    <span>
      {t(`${EN_PATH}.message1`)}
      <a href={SUPPORT_LINK} target="_blank" rel="noopener noreferrer">
        {t(`${EN_PATH}.contact`)}
      </a>
      {t(`${EN_PATH}.message2`)}
    </span>
  );
};
